import { createCapabilityChecker } from '@/features/authentication/lib/authorizationCapabilities';
import { availableOperationsQuery } from '@/features/authentication/services/permissionQueries';
import type {
  AvailableOperationsResponse,
  CapabilityPredicate,
} from '@/features/authentication/types/permissions';
import type { RouterContext } from '@/routes/__root';
import { isForbidden } from '@/shared/api/client';
import { LOGIN_ROUTE, waitForAuth } from '@/shared/lib/authSession';
import { redirect } from '@tanstack/react-router';

interface GuardArgs {
  context: RouterContext;
  params: Record<string, string>;
}

/** Guard broad routes with the backend's true-only availability map. */
export function requireCapabilities(predicate: CapabilityPredicate) {
  return async ({ context }: GuardArgs): Promise<void> => {
    const user = await waitForAuth();
    if (!user) throw redirect({ to: LOGIN_ROUTE });
    let available: AvailableOperationsResponse;
    try {
      available = await context.queryClient.ensureQueryData(availableOperationsQuery(user.uid));
    } catch (error) {
      if (isForbidden(error)) throw redirect({ to: '/forbidden', replace: true });
      throw error;
    }
    if (!predicate(createCapabilityChecker(available))) {
      throw redirect({ to: '/forbidden', replace: true });
    }
  };
}
